import { render, staticRenderFns } from "./FooterContacts.vue?vue&type=template&id=c75fc15c"
import script from "./FooterContacts.vue?vue&type=script&lang=js"
export * from "./FooterContacts.vue?vue&type=script&lang=js"
import style0 from "./FooterContacts.vue?vue&type=style&index=0&id=c75fc15c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports